const peiCheckListStatus = {
  Completado: 289,
  NoCompletado: 290,
};
export default peiCheckListStatus;
